// Token for scanner/kiosk devices (no Supabase user session), issued by the
// device-login edge function and sent as X-Device-Token to edge functions and the pass server.
const STORAGE_KEY = 'taginn_device_token';

export const DEVICE_TOKEN_HEADER = 'X-Device-Token';

interface StoredDeviceToken {
  token: string;
  expires_at: string;
}

export function setDeviceToken(token: string, expiresAt: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, expires_at: expiresAt }));
  } catch {
    // storage blocked (private mode): the device must log in again after reload
  }
}

export function getDeviceToken(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const stored = JSON.parse(raw) as StoredDeviceToken;
    if (new Date(stored.expires_at).getTime() <= Date.now()) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return stored.token;
  } catch {
    return null;
  }
}

export function clearDeviceToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // nothing to clear
  }
}

/** Headers to spread into a fetch/invoke call; empty when the device is not logged in. */
export function deviceTokenHeaders(): Record<string, string> {
  const token = getDeviceToken();
  return token ? { [DEVICE_TOKEN_HEADER]: token } : {};
}
